// extracted by mini-css-extract-plugin
module.exports = {"CheckboxButton":"classes_CheckboxButton__1fHyI","buttonCheckBox2":"classes_buttonCheckBox2__1i0nN"};